<template>
  <div>首页</div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {};
  },
  created() {
    let mode = localStorage.getItem("mode");
    if (mode == 2) {
      this.$router.replace({ name: "gonghuiShenheIndex" });
    } else {
      this.$router.replace({ name: "zhiweiIndex" });
    }
  }
};
</script>

<style lang="less">
.count-style {
  font-size: 50px;
}
</style>
